<template>
  <section id="employers-lt-order" class="employers-pl-order  container">
    <div class="employers-pl-order__round-figure _top-green"></div>
    <div class="employers-pl-order__round-figure _bottom-blue"></div>

    <div class="employers-pl-order__content  container-inner">
      <h2 class="employers-pl-order__title">{{ section.title || section.heading }}</h2>

      <div class="employers-pl-order__inputs-list">
        <BaseInput v-if="canUseField('company_name')"
                   :label="labels.company_name || section.field1"
                   v-model="inputs.company_name.value"
                   :error="inputs.company_name.error"
                   :required="inputs.company_name.required"
                   class="employers-pl-order__input _company-name _white"/>
        <BaseInput v-if="canUseField('company_code')"
                   :label="labels.company_code || section.field2"
                   v-model="inputs.company_code.value"
                   :error="inputs.company_code.error"
                   :required="inputs.company_code.required"
                   mask="##########"
                   class="employers-pl-order__input  _company-code _white"/>
        <BaseInput v-if="canUseField('contact_person')"
                   :label="labels.contact_person || section.field3"
                   v-model="inputs.contact_person.value"
                   :error="inputs.contact_person.error"
                   :required="inputs.contact_person.required"
                   class="employers-pl-order__input  _first-name _white"/>
        <BaseInputPhone v-if="canUseField('phone')"
                        :key="key"
                        :label="labels.phone || section.field4"
                        v-model="inputs.phone.value"
                        :error="inputs.phone.error"
                        :required="inputs.phone.required"
                        defaultCountry="pl"
                        class="employers-pl-order__input  _phone _white"/>
        <BaseInput v-if="canUseField('email')"
                   :label="labels.email || section.field5"
                   v-model="inputs.email.value"
                   :error="inputs.email.error"
                   :required="inputs.email.required"
                   type="email"
                   class="employers-pl-order__input  _email _white"/>
      </div>

      <div class="d-flex justify-center mt-5">
        <BaseCheckbox
          v-if="canUseField('i_agree')"
          v-model="agree"
          class="employers-pl-order__agree"
        >
          <div slot="label"
               class="checkbox__text">
            {{ labels.i_agree || section.i_agree }}
            <router-link-modified :to="section.privacy_policy_link || {name: 'privacy-policy'}">
              {{ labels.i_agree_link || section.i_agree_link || section.privacy_policy }}
            </router-link-modified>
          </div>
        </BaseCheckbox>
      </div>

      <BaseAlertInline :value="lastResponseStatus >= 500 && overallErrorsMix"
                       class="employers-pl-order__error  _error"/>

      <div class="d-flex justify-center">
        <button
          class="employers-pl-order__btn  base-btn  base-btn--blue"
          :disabled="!agree"
          @click.prevent="send"
        >
          <span>{{ section.button.text || section.button }}</span>
          <BasePreloader v-if="pending" class="_small" />
        </button>
      </div>
    </div>
  </section>
</template>

<script>
  import formMixins from '@/mixins/formMixins'
  import BaseAlertInline from '@/components/BaseAlertInline'
  import {http} from '@/axios'

  function getInputs(vm) {
    return {
      company_name: {
        value: null,
        required: false
      },
      company_code: {
        value: null,
        required: false
      },
      contact_person: {
        value: null,
        required: false
      },
      phone: {
        value: null,
        required: false
      },
      email: {
        value: null,
        required: true,
        validate: [{
          regexp: '([\\w\\.\\-_]+)?\\w+@[\\w-_]+(\\.\\w+){1,}',
          error: vm.section.invalid_email
        }]
      },
    }
  }

  export default {
    name: 'EmployersLTPageOrder',
    mixins: [formMixins],
    components: {
      BaseAlertInline,
    },
    props: {
      section: Object,
      labels: {
        type: Object,
        default: () => ({}),
      },
      useOnlyFields: {
        type: Array,
        default: null,
      },
      requestUrl: {
        type: String,
        default: '/api/helper/landing/employer-poland-send',
      },
    },
    data(vm) {
      return {
        key: 1,
        pending: null,
        agree: false,
        inputs: getInputs(vm),
        lastResponseStatus: null,
      }
    },
    methods: {
      canUseField(fieldKey) {
        if (!this.useOnlyFields) return true;
        return this.useOnlyFields.includes(fieldKey);
      },
      reset() {
        this.inputs = getInputs(this)
        this.key = ++this.key
        this.agree = false;
      },
      send() {
        this.lastResponseStatus = null;
        this.resetErrorsMix()

        const inputs = this.getUsedInputs();
        const result = this.createSendDataMix(inputs, { skipErrors: true });

        if (!this.validateEmail(this.inputs.email.value)) {
          this.inputs.email.error = ['Invalid email'];
          return;
        }

        this.pending = true

        http.post(this.requestUrl, result)
            .then(() => {
              this.$vModal.open('successfully-sent', {
                title: this.section['modal_successfully_sent_title'],
                text: this.section['modal_successfully_sent_text'],
                button: this.section['modal-successfully-sent-button'],
              });

              this.reset();
            })
            .catch(e => {
              this.lastResponseStatus = e.response.status;
              this.errorHandlerMix(e, this.inputs)
            })
            .finally(() => {
              this.pending = false
            })
      },
      validateEmail(value) {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/img.test(value)
      },
      getUsedInputs() {
        if (!this.useOnlyFields) return this.inputs;
        const filteredEntries = Object.entries(this.inputs).filter(i => this.useOnlyFields.includes(i[0]));
        return Object.fromEntries(filteredEntries);
      },
    }
  }
</script>

<style lang="less">

</style>
